import { Component } from '@angular/core'

@Component({
  selector: 'app-entity-group',
  templateUrl: './entity-group.component.html',
  standalone: false
})
export class EntityGroupComponent {}
